import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input, Select } from 'antd'

interface BlocklistEntry {
  term: string
  severity: 'block' | 'warn'
}

export function TextBlocklistEdit() {
  const { formProps, saveButtonProps } = useForm<BlocklistEntry>({
    resource: 'text_blocklist',
    meta: { idColumnName: 'term' },
  })

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Term" name="term">
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Severity"
          name="severity"
          rules={[{ required: true }]}
          extra='"block" hard-rejects UGC on the server. "warn" shows a client-side inline warning.'
        >
          <Select
            options={[
              { label: 'block — hard-reject on server', value: 'block' },
              { label: 'warn — soft warning on client', value: 'warn' },
            ]}
          />
        </Form.Item>
      </Form>
    </Edit>
  )
}
